import styled from 'styled-components';

export const ArtToolsStyled = styled.div`
  position: relative;
  padding-top: 0;
  padding-bottom: 120px;
  background: var(--white);
  overflow: hidden;
  @media (min-width: 393px) {
    padding-bottom: 100px;
  }
  @media (min-width: 992px) {
    padding-bottom: 150px;
  }
`;

export const UseCasesDiagonalGrayTop = styled.div`
  background: var(--white);
  width: 100%;
  @media (min-width: 992px) {
    padding: 30px;
    clip-path: polygon(0 90%, 100% 0, 100% 0, 0 0);
  }
`;

export const Title = styled.h4`
  color: var(--black);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
  text-align: center;
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 992px) {
    br {
      display: none;
    }
  }
`;

export const ToolsContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin-top: 65px;
  padding: 0 20px;
  @media (min-width: 992px) {
    justify-content: center;
  }
  @media (min-width: 1520px) {
    margin: 0 auto;
    margin-top: 111px;
    padding: 0;
    height: 255px;
    width: 1512px;
    /*transform: translateX(-3%);*/
    align-items: center;
    justify-content: space-between;
  }
`;

export const Tool = styled.div`
  height: 199px;
  margin-bottom: 41px;
  flex: 1;
  max-width: 168px;
  &.hide {
    visibility: hidden;
  }
  @media (min-width: 1440px) {
    height: 215px;
    margin-bottom: 0;
    &:nth-of-type(even) {
      align-self: flex-start;
    }
    &:nth-of-type(odd) {
      align-self: flex-end;
    }
  }
`;

export const ToolIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  background-color: var(--lgray);
  height: 168px;
  width: 155px;
  @media (min-width: 1440px) {
    height: 168px;
    width: 168px;
  }
`;

export const ToolTitle = styled.h4`
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  margin-top: 23px;
`;
